import payments from './payments'

export default [
  {
    label: 'General',
    path: 'general',
    fields: [
      { label: 'Name', type: 'c-input', path: 'name' },
      { label: 'Locale', type: 'c-select', path: 'locale' },
      { label: 'Secret', type: 'c-input', path: 'secret' },
      { label: 'Https', type: 'c-switch', path: 'https' },
      { label: 'Domains', type: 'c-tag-input', path: 'domain' },
      { label: 'Custom Config', type: 'c-switch', path: 'customConfig' },
    ],
  },
  {
    label: 'Project',
    path: 'project',
    fields: [
      { label: 'Name', type: 'c-input', path: 'core.configuration.project.name' },
      { label: 'Locale', type: 'c-select', path: 'core.configuration.project.locale' },
      { label: 'Locales', type: 'c-multi-select', path: 'core.configuration.project.locales' },
      { label: 'Odds Format', type: 'c-select', path: 'core.configuration.project.odds_format' },
      // A SELECT of UTC offsets, not free text and not city names (owner decision 2026-08-26). The
      // choices come from the server's own form payload, exactly as Locale and Odds Format do -- the
      // configurator's ProjectType declares them (ProjectBundle\Utils\Timezones), so this list can never
      // drift from what the API will accept. Empty = UTC.
      //
      // Offsets rather than zone names because the backend mechanics that grid on a fixed-length day (the
      // cashback accrual cell, the weekly deposit window) REFUSE to run in a DST zone; a numeric offset
      // cannot observe DST, so the failure is unreachable rather than merely detectable.
      { label: 'Timezone', type: 'c-select', path: 'core.configuration.project.timezone' },
      { label: 'Session Duration', type: 'c-input', path: 'core.configuration.project.session_duration' },
      { label: 'Items on Page', type: 'c-input', path: 'core.configuration.on_page' },
      { label: 'Index Route', type: 'b-input', path: 'frontConfiguration.data.indexRoute' },
      { label: 'Theme', type: 'b-input', path: 'frontConfiguration.data.theme' },
      {
        label: 'Backend Conf Cache',
        type: 'c-switch',
        path: 'core.configuration.project.cachedConfiguration',
      },
      {
        label: 'Translations',
        fields: [
          { label: 'URL', type: 'b-input', path: 'frontConfiguration.data.translations.api' },
          { label: 'Token', type: 'b-input', path: 'frontConfiguration.data.translations.token' },
        ],
      },
    ],
  },
  {
    label: 'Database',
    path: 'database',
    fields: [
      { label: 'Host', type: 'c-input', path: 'database.host' },
      { label: 'Port', type: 'c-input', path: 'database.port' },
      { label: 'Name', type: 'c-input', path: 'database.name' },
      { label: 'User', type: 'c-input', path: 'database.user' },
      { label: 'Password', type: 'c-input', path: 'database.password' },
      { label: 'Slaves', type: 'c-multi-array-input', path: 'database.slaves' },
    ],
  },
  {
    label: 'Frontend',
    path: 'frontend',
    fields: [
      { label: 'Admin Path', type: 'c-input', path: 'frontend.admin' },
      { label: 'Frontend Path', type: 'c-input', path: 'frontend.frontend' },
      {
        label: 'Exchange',
        fields: [
          { label: 'Enabled', type: 'c-switch', path: 'frontend.exchange.enabled' },
          { label: 'Path', type: 'c-input', path: 'frontend.exchange.path' },
        ],
      },
      {
        label: 'Mobile',
        fields: [
          { label: 'Enabled', type: 'c-switch', path: 'frontend.mobile.enabled' },
          { label: 'Path', type: 'c-input', path: 'frontend.mobile.path' },
        ],
      },
      {
        label: 'Agent System',
        fields: [
          { label: 'Enabled', type: 'c-switch', path: 'frontend.agent.enabled' },
          { label: 'Path', type: 'c-input', path: 'frontend.agent.path' },
        ],
      },
      {
        label: 'Partner System',
        fields: [
          { label: 'Enabled', type: 'c-switch', path: 'frontend.partner.enabled' },
          { label: 'Path', type: 'c-input', path: 'frontend.partner.path' },
        ],
      },
    ],
  },
  {
    label: 'Currencies',
    path: 'currencies',
    fields: [
      { label: 'Rate', type: 'c-select', path: 'core.configuration.currency.rate' },
      { label: 'Default', type: 'c-select', path: 'core.configuration.currency.default' },
      { label: 'View', type: 'c-multi-select', path: 'core.configuration.currency.view' },
      { label: 'Available', type: 'c-multi-select', path: 'core.configuration.currency.available' },
    ],
  },
  { label: 'Payments', path: 'payments', enabledPath: 'payment.enabled', children: payments },
  {
    label: 'Modules',
    path: 'modules',
    children: [
      {
        label: 'Admin',
        path: 'admin',
        fields: [
          { label: 'TFA Enabled', type: 'c-switch', path: 'admin.configuration.tfa_enabled' },
          { label: 'TFA on Withdraw', type: 'c-switch', path: 'admin.configuration.tfa_on_withdraw' },
          { label: 'Show Currencies', type: 'b-switch', path: 'frontConfiguration.data.currencies.visible' },
        ],
      },
      {
        label: 'Exchange Settings',
        path: 'exchange-settings',
        fields: [
          {
            label: 'Enable Multimarkets',
            type: 'b-switch',
            path: 'frontConfiguration.data.exchanges.multimarkets.enabled',
          },
          {
            label: 'Enable Quick Bets',
            type: 'b-switch',
            path: 'frontConfiguration.data.exchanges.bets.quick.enabled',
          },
          {
            label: 'Enable Bet Confirm',
            type: 'b-switch',
            path: 'frontConfiguration.data.exchanges.bets.confirm.enabled',
          },
          {
            label: 'Default Bet Confirm',
            type: 'b-switch',
            path: 'frontConfiguration.data.exchanges.bets.confirm.default',
          },
          {
            label: 'Enable Default Bets',
            type: 'b-switch',
            path: 'frontConfiguration.data.exchanges.bets.defaults.enabled',
          },
          {
            label: 'Show Real Liquidity',
            type: 'b-switch',
            path: 'frontConfiguration.data.exchanges.realLiquidity.show',
          },
          {
            label: 'Open Markets Count',
            type: 'c-input',
            path: 'frontConfiguration.data.exchanges.markets.open.count',
          },
        ],
      },
      { label: 'Agent System', path: 'agent', enabledPath: 'agent.enabled' },
      {
        label: 'Achievements',
        path: 'achievements',
        enabledPath: 'achievement.enabled',
        fields: [
          {
            label: 'Win Points',
            fields: [
              { label: 'Enabled', type: 'c-switch', path: 'achievement.configuration.win_points.enabled' },
              { label: 'Percent', type: 'c-input', path: 'achievement.configuration.win_points.percent' },
              { label: 'Min Stake', type: 'c-input', path: 'achievement.configuration.win_points.stake_min' },
            ],
          },
        ],
      },
      {
        label: 'Achievements2',
        path: 'achievements2',
        enabledPath: 'achievement2.enabled',
        fields: [
          { label: 'Frontend Enabled', type: 'b-switch', path: 'frontConfiguration.data.achievements2.api' },
        ],
      },
      {
        label: 'Lottery',
        path: 'millioner',
        enabledPath: 'millioner.enabled',
        fields: [],
      },
      {
        label: 'messenger',
        path: 'messenger',
        enabledPath: 'messenger.enabled',
        fields: [],
      },
      {
        label: 'Freebet',
        path: 'freebet',
        enabledPath: 'freebet.enabled',
        fields: [],
      },
      {
        label: 'Betfair',
        path: 'betfair',
        enabledPath: 'betfair.enabled',
        fields: [
          { label: 'Api URL', type: 'c-input', path: 'betfair.configuration.api' },
          { label: 'Frontend Api URL', type: 'c-input', path: 'frontConfiguration.data.betfair.api' },
          { label: 'Account ID', type: 'c-input', path: 'betfair.configuration.account_id' },
          { label: 'Commission', type: 'c-input', path: 'betfair.configuration.commission' },
          { label: 'Manual', type: 'c-switch', path: 'betfair.configuration.manual' },
          { label: 'Exposure Limit', type: 'c-input', path: 'betfair.configuration.exposure_limit' },
          {
            label: 'Exposure Limit Enabled',
            type: 'c-switch',
            path: 'betfair.configuration.exposure_limit_enabled',
          },
          {
            label: 'Low Liquidity Check',
            fields: [
              {
                label: 'Enabled',
                type: 'b-switch',
                path: 'frontConfiguration.data.betfair.lowLiquidityCheck.enabled',
              },
              {
                label: 'Min Total Available',
                type: 'c-input',
                valueType: 'integer',
                path: 'frontConfiguration.data.betfair.lowLiquidityCheck.minTotalAvailable',
              },
              {
                label: 'Min Total Matched',
                type: 'c-input',
                valueType: 'integer',
                path: 'frontConfiguration.data.betfair.lowLiquidityCheck.minTotalMatched',
              },
            ],
          },
          {
            label: 'Show Liquidity Everywhere',
            type: 'b-switch',
            path: 'frontConfiguration.data.betfair.showLiquidityEverywhere',
          },
          ...getExchangeSettings('betfair'),
        ],
      },
      {
        label: 'Dabba',
        path: 'dabba',
        enabledPath: 'dabba.enabled',
        fields: [
          { label: 'Api URL', type: 'c-input', path: 'dabba.configuration.api' },
          { label: 'Frontend Api URL', type: 'c-input', path: 'frontConfiguration.data.dabba.api' },
          { label: 'Account Id', type: 'c-input', path: 'dabba.configuration.account_id' },
          { label: 'Admin Token', type: 'c-input', path: 'dabba.configuration.admin_token' },
          {
            label: 'Show Liquidity Everywhere',
            type: 'b-switch',
            path: 'frontConfiguration.data.betfair.showLiquidityEverywhere',
          },
          ...getExchangeSettings('dabba'),
        ],
      },
      {
        label: 'Exchange',
        path: 'exchange',
        enabledPath: 'exchange.enabled',
        fields: [
          { label: 'Api URL', type: 'c-input', path: 'exchange.configuration.api' },
          { label: 'Frontend Api URL', type: 'c-input', path: 'frontConfiguration.data.exchange.api' },
          { label: 'Token', type: 'c-input', path: 'exchange.configuration.token' },
          { label: 'Commission', type: 'c-input', path: 'exchange.configuration.commission' },
          {
            label: 'Sources',
            fields: [{ type: 'exchange-sources', path: 'frontConfiguration.data.exchange.sources' }],
          },
          {
            label: 'Bet Submit Delay (ms)',
            type: 'c-input',
            valueType: 'integer',
            path: `frontConfiguration.data.exchange.betslip.submitDelay`,
          },
          {
            label: 'Show Liquidity Everywhere',
            type: 'b-switch',
            path: 'frontConfiguration.data.exchange.showLiquidityEverywhere',
          },
        ],
      },
      {
        label: 'Darwin ',
        path: 'darwin',
        enabledPath: 'darwin.enabled',
        fields: [
          { label: 'Password', type: 'c-input', path: 'darwin.configuration.password' },
          { label: 'Username', type: 'c-input', path: 'darwin.configuration.username' },
          { label: 'Casino Id', type: 'c-input', path: 'darwin.configuration.casino_id' },
          { label: 'Lobby Url', type: 'c-input', path: 'darwin.configuration.lobbyUrl' },
        ],
      },
      {
        label: 'Huidu ',
        path: 'huidu',
        enabledPath: 'huidu.enabled',
        fields: [
          { label: 'UID', type: 'c-input', path: 'huidu.configuration.agency_uid' },
          { label: 'AES Key', type: 'c-input', path: 'huidu.configuration.aes_key' },
          { label: 'Server Url', type: 'c-input', path: 'huidu.configuration.server_url' },
          { label: 'Language', type: 'c-input', path: 'huidu.configuration.language' },
          { label: 'Prefix', type: 'c-input', path: 'huidu.configuration.prefix' },
        ],
      },
      {
        label: 'Twoj',
        path: 'twoj',
        enabledPath: 'twoj.enabled',
        fields: [
          { label: 'MCH INR', type: 'c-input', path: 'twoj.configuration.mch.INR' },
          { label: 'MCH USD', type: 'c-input', path: 'twoj.configuration.mch.USD' },
          { label: 'MCH PKR', type: 'c-input', path: 'twoj.configuration.mch.PKR' },
          { label: 'MCH BDT', type: 'c-input', path: 'twoj.configuration.mch.BDT' },
          { label: 'Key', type: 'c-input', path: 'twoj.configuration.key' },
          { label: 'Api URL', type: 'c-input', path: 'twoj.configuration.api_url' },
          { label: 'Country code', type: 'c-input', path: 'twoj.configuration.country_code' },
        ],
      },
      {
        label: 'Jili',
        path: 'ji_li',
        enabledPath: 'ji_li.enabled',
        fields: [
          { label: 'Agent Key', type: 'c-input', path: 'ji_li.configuration.agent_key' },
          { label: 'Api Url', type: 'c-input', path: 'ji_li.configuration.api_url' },
          { label: 'Language', type: 'c-input', path: 'ji_li.configuration.lang' },
          { label: 'Agent Id', type: 'c-input', path: 'ji_li.configuration.agent_id' },
        ],
      },
      {
        label: 'Session Games',
        path: 'session-games',
        enabledPath: 'session_games.enabled',
        fields: [
          { label: 'Api URL', type: 'c-input', path: 'session_games.configuration.api' },
          { label: 'Frontend Api URL', type: 'c-input', path: 'frontConfiguration.data.sessionGames.api' },
          { label: 'Token', type: 'c-input', path: 'session_games.configuration.token' },
          {
            label: 'Admin Token',
            type: 'b-input',
            path: 'frontConfiguration.data.sessionGames.adminToken',
          },
          {
            label: 'Automate',
            type: 'b-switch',
            path: 'frontConfiguration.data.sessionGames.automateGames',
          },
          {
            label: 'Bet submit delay (ms)',
            type: 'c-input',
            valueType: 'integer',
            path: 'frontConfiguration.data.sessionGames.betslip.submitDelay',
          },
        ],
      },
      {
        label: 'Bolobhai',
        path: 'bolobhai',
        enabledPath: 'bolobhai.enabled',
        fields: [
          {
            label: 'Api URL',
            type: 'c-input',
            path: 'bolobhai.configuration.api',
          },
          {
            label: 'Casino ID',
            type: 'c-input',
            valueType: 'integer',
            path: 'bolobhai.configuration.casino_id',
          },
          {
            label: 'Secret Key',
            type: 'c-input',
            path: 'bolobhai.configuration.secret_key',
          },
        ],
      },
      {
        label: 'Spribe',
        path: 'spribe',
        enabledPath: 'spribe.enabled',
        fields: [
          {
            label: 'Api URL',
            type: 'c-input',
            path: 'spribe.configuration.api',
          },
          {
            label: 'Secret Key',
            type: 'c-input',
            path: 'spribe.configuration.secret_key',
          },
          {
            label: 'Operator ID',
            type: 'c-input',
            path: 'spribe.configuration.operator_id',
          },
          {
            label: 'Launch URL',
            type: 'c-input',
            path: 'spribe.configuration.launch_url',
          },
        ],
      },
      {
        label: 'TurboSports',
        path: 'turbo_sports',
        enabledPath: 'turbo_sports.enabled',
        fields: [
          {
            label: 'CID',
            type: 'c-input',
            path: 'turbo_sports.configuration.cid',
          },
          {
            label: 'Secret Key',
            type: 'c-input',
            path: 'turbo_sports.configuration.secret_key',
          },
          {
            label: 'Api URL',
            type: 'c-input',
            path: 'turbo_sports.configuration.api_url',
          },
        ],
      },
      {
        label: 'Fancy Games',
        path: 'fancy-games',
        enabledPath: 'fancy_games.enabled',
        fields: [
          { label: 'Api URL', type: 'c-input', path: 'fancy_games.configuration.api' },
          { label: 'Token', type: 'c-input', path: 'fancy_games.configuration.token' },
          { label: 'Secret Key', type: 'c-input', path: 'fancy_games.configuration.secret_key' },
          {
            label: 'Base Url Linking Events',
            type: 'c-input',
            path: 'fancy_games.configuration.base_url_linking_events',
          },
        ],
      },
      {
        label: 'Sportsbook',
        path: 'sportsbook',
        enabledPath: 'sport_book.enabled',
        fields: [
          { label: 'Admin URL', type: 'c-input', path: 'sport_book.configuration.admin' },
          { label: 'Api URL', type: 'c-input', path: 'sport_book.configuration.api' },
          { label: 'Frontend Api URL', type: 'c-input', path: 'frontConfiguration.data.sportsbook.api' },
          { label: 'Print URL', type: 'c-input', path: 'frontConfiguration.data.bts.printUrl' },
          { label: 'Token', type: 'c-input', path: 'sport_book.configuration.token' },
          { label: 'MTS Limit ID', type: 'c-input', path: 'sport_book.configuration.mts_limit_id' },
          { label: 'Parlay Bonus', type: 'c-switch', path: 'sport_book.configuration.bonus_parlay' },
          { label: 'Cancelable', type: 'c-switch', path: 'sport_book.configuration.cancelled' },
          {
            label: 'Sources',
            fields: [{ type: 'sportsbook-source', path: 'frontConfiguration.data.sportsbook.sources' }],
          },
          {
            label: 'Bet Submit Delay (ms)',
            type: 'c-input',
            valueType: 'integer',
            path: `frontConfiguration.data.sportsbook.betslip.submitDelay`,
          },
          {
            label: 'Parlay Limit',
            type: 'c-input',
            valueType: 'integer',
            path: 'frontConfiguration.data.sportsbook.betslip.parlayLimit',
          },
          {
            label: 'Double Chance Limit',
            type: 'b-switch',
            path: 'frontConfiguration.data.sportsbook.betslip.doubleChanceLimit',
          },
          {
            label: 'Max Stake',
            type: 'b-switch',
            path: 'frontConfiguration.data.sportsbook.betslip.maxStake',
          },
        ],
      },
      {
        label: 'SportsLotto',
        path: 'sports_lotto',
        enabledPath: 'sports_lotto.enabled',
        fields: [{ label: 'Api URL', type: 'c-input', path: 'sports_lotto.configuration.api' }],
      },
      { label: 'Flash Games', path: 'flash-games', enabledPath: 'flash_games.enabled' },
      {
        label: 'SoftSwiss',
        path: 'softswiss',
        enabledPath: 'soft_swiss.enabled',
        fields: [
          { label: 'Backend URL', type: 'c-input', path: 'soft_swiss.configuration.backendUrl' },
          { label: 'Script URL', type: 'c-input', path: 'soft_swiss.configuration.scriptUrl' },
          { label: 'Auth Token', type: 'c-input', path: 'soft_swiss.configuration.authToken' },
          { label: 'Casino ID', type: 'c-input', path: 'soft_swiss.configuration.casinoId' },
          { label: 'Providers', type: 'c-multi-checkbox', path: 'softSwissProviders' },
        ],
      },
      {
        label: 'XPG Casino',
        path: 'xpg_casino',
        enabledPath: 'xpg_casino.enabled',
        fields: [
          { label: 'API url', type: 'c-input', path: 'xpg_casino.configuration.api_url' },
          { label: 'Name', type: 'c-input', path: 'xpg_casino.configuration.name' },
          { label: 'Operator id', type: 'c-input', path: 'xpg_casino.configuration.operator_id' },
          { label: 'Private key', type: 'c-input', path: 'xpg_casino.configuration.private_key' },
          { label: 'Lobby url', type: 'c-input', path: 'xpg_casino.configuration.lobby_url' },
        ],
      },
      {
        label: 'Ezugi Casino',
        path: 'ezugi',
        enabledPath: 'ezugi.enabled',
        fields: [
          { label: 'Operator id', type: 'c-input', path: 'ezugi.configuration.operator_id' },
          { label: 'Name', type: 'c-input', path: 'ezugi.configuration.name' },
          { label: 'Private Key', type: 'c-input', path: 'ezugi.configuration.private_key' },
          { label: 'Api URL', type: 'c-input', path: 'ezugi.configuration.api_url' },
          { label: 'Lobby url', type: 'c-input', path: 'ezugi.configuration.lobby_url' },
          { label: 'Language', type: 'c-select', path: 'ezugi.configuration.language' },
        ],
      },
      {
        label: 'Inout',
        path: 'inout',
        enabledPath: 'inout.enabled',
        fields: [
          { label: 'Operator id', type: 'c-input', path: 'inout.configuration.operator_id' },
          { label: 'Name', type: 'c-input', path: 'inout.configuration.name' },
          { label: 'Private Key', type: 'c-input', path: 'inout.configuration.private_key' },
          { label: 'Api URL', type: 'c-input', path: 'inout.configuration.api_url' },
          { label: 'Lobby url', type: 'c-input', path: 'inout.configuration.lobby_url' },
          { label: 'Language', type: 'c-select', path: 'inout.configuration.language' },
          { label: 'Country Code', type: 'c-input', path: 'inout.configuration.country_code' },
        ],
      },
    ],
  },
  {
    label: 'Bets',
    path: 'bets',
    fields: [
      {
        label: 'One click betting',
        fields: [
          { label: 'Enabled', type: 'b-switch', path: 'frontConfiguration.data.oneClickBetting.enabled' },
          { label: 'Default Bet Values', type: 'c-tag-input', path: 'bet.configuration.default_bet_values' },
        ],
      },
      {
        label: 'Post Affiliate Pro',
        fields: [
          { label: 'Enabled', type: 'c-switch', path: 'bet.configuration.post_affiliate_pro.enabled' },
          { label: 'Merchant ID', type: 'c-input', path: 'bet.configuration.post_affiliate_pro.merchant_id' },
          { label: 'Api Host', type: 'c-input', path: 'bet.configuration.post_affiliate_pro.api_host' },
          {
            label: 'Commission Percent',
            type: 'c-input',
            path: 'bet.configuration.post_affiliate_pro.commissionPercent',
          },
        ],
      },
    ],
  },
  {
    label: 'User',
    path: 'user',
    children: [
      {
        label: 'Settings',
        path: 'settings',
        fields: [
          { label: 'Licence', type: 'c-select', path: 'user.configuration.license' },
          { label: 'Resetting TTL', type: 'c-input', path: 'user.configuration.ttl' },
          { label: 'Risk Score', type: 'c-input', path: 'user.configuration.risk_score' },
          { label: 'Auto login', type: 'c-switch', path: 'user.configuration.auto_login' },
          { label: 'Unique Phone', type: 'c-switch', path: 'user.configuration.unique_phone' },
          { label: 'TFA', type: 'c-switch', path: 'user.configuration.tfa' },
          { label: 'Limit Payments', type: 'b-switch', path: 'frontConfiguration.data.show_all_payments' },
          { label: 'Enabled Tracking', type: 'c-switch', path: 'user.configuration.is_tracking_enabled' },
          { label: 'Login Required', type: 'b-switch', path: 'frontConfiguration.data.login.required' },
          { label: 'Registration Status', type: 'c-select', path: 'user.configuration.registration_status' },
          {
            type: 'frontend-registration-type',
            path: 'frontConfiguration.data.registration.type',
          },
          {
            type: 'frontend-registration-password-strength',
            path: 'frontConfiguration.data.registration.passwordStrength',
          },
          {
            label: 'Login Terms Check',
            type: 'b-switch',
            path: 'frontConfiguration.data.login.termsCheck',
          },
          {
            label: 'Responsible Gambling',
            type: 'b-switch',
            path: 'frontConfiguration.data.responsibleGambling',
          },
          {
            label: 'Display Currency',
            type: 'b-switch',
            path: 'frontConfiguration.data.displayCurrency',
          },
          {
            label: 'Leaderboard',
            type: 'c-switch',
            path: 'user.configuration.leaderboard',
          },
          {
            label: 'Fields',
            type: 'user-fields',
            path: 'frontConfiguration.data.user.fields',
          },
        ],
      },
      {
        label: 'Permissions',
        path: 'permissions',
        fields: [
          {
            type: 'user-permissions',
            path: 'frontConfiguration.data.permissions',
          },
        ],
      },
      {
        label: 'Recaptcha',
        path: 'recaptcha',
        enabledPath: 'user.configuration.recaptcha.enabled',
        fields: [
          { label: 'Secret', type: 'c-input', path: 'user.configuration.recaptcha.secret' },
          { label: 'On Login(front)', type: 'b-switch', path: 'frontConfiguration.data.recaptcha.on_login' },
          {
            label: 'On Register(front)',
            type: 'b-switch',
            path: 'frontConfiguration.data.recaptcha.on_register',
          },
          { label: 'On Login(back)', type: 'c-switch', path: 'user.configuration.recaptcha.on_login' },
          { label: 'On Register(back)', type: 'c-switch', path: 'user.configuration.recaptcha.on_register' },
          { label: 'Site key', type: 'c-input', path: 'frontConfiguration.data.recaptcha.site_key' },
        ],
      },
      {
        label: 'Verification',
        path: 'verification',
        fields: [
          {
            label: 'Enabled',
            type: 'c-multi-select',
            path: 'user.configuration.verification.enabled',
          },
          {
            label: 'Rules',
            type: 'user-verification',
            path: 'user.configuration.verification.result',
            payload: {
              enabled: 'user.configuration.verification.enabled',
            },
          },
          {
            label: 'Notification',
            type: 'b-switch',
            path: 'frontConfiguration.data.verification.notification',
          },
          {
            label: 'W2 Global',
            fields: [
              {
                label: 'Api Key',
                type: 'c-input',
                path: 'user.configuration.verification.w2_global.api_key',
              },
              {
                label: 'Is Sandbox',
                type: 'c-switch',
                path: 'user.configuration.verification.w2_global.is_sandbox',
              },
            ],
          },
          {
            label: 'Gam Stop',
            fields: [
              {
                label: 'Api Key',
                type: 'c-input',
                path: 'user.configuration.verification.gam_stop.api_key',
              },
              {
                label: 'Operator Id',
                type: 'c-input',
                path: 'user.configuration.verification.gam_stop.operator_id',
              },
              {
                label: 'Url',
                type: 'c-input',
                path: 'user.configuration.verification.gam_stop.url',
              },
            ],
          },
          {
            label: 'Neverbounce',
            fields: [
              {
                label: 'Api Key',
                type: 'c-input',
                path: 'user.configuration.verification.never_bounce.api_key',
              },
              {
                label: 'Frontend Api Key',
                type: 'b-input',
                path: 'frontConfiguration.data.neverBounce.apiKey',
              },
              {
                label: 'Url',
                type: 'c-input',
                path: 'user.configuration.verification.never_bounce.url',
              },
            ],
          },
        ],
      },
      {
        label: 'JWT',
        path: 'jwt',
        fields: [
          { label: 'Secret', type: 'c-input', path: 'user.configuration.jwt.secret' },
          { label: 'TTL', type: 'c-input', path: 'user.configuration.jwt.ttl' },
        ],
      },
      {
        label: 'Firebase',
        path: 'firebase',
        enabledPath: 'core.configuration.firebase.enabled',
        fields: [
          { label: 'Project ID', type: 'c-input', path: 'core.configuration.firebase.project_id' },
          { label: 'Client ID', type: 'c-input', path: 'core.configuration.firebase.client_id' },
          { label: 'Client Email', type: 'c-input', path: 'core.configuration.firebase.client_email' },
          { label: 'Private Key', type: 'c-input', path: 'core.configuration.firebase.private_key' },
        ],
      },
      // Childless on purpose: the loyalty bundle takes NO setting from the configurator, only its own
      // on/off toggle. Everything an operator can tune (the level ladder, the per-level overrides, the
      // qualifying minimums) lives in the tenant's own admin panel. The ONE configurator-class setting the
      // feature needs is the project timezone, and that is not a loyalty key -- it is above, under Project.
      { label: 'Loyalty', path: 'loyalty', enabledPath: 'loyalty.enabled' },
      {
        label: 'Bonus',
        path: 'bonus',
        enabledPath: 'bonus.enabled',
        fields: [
          {
            label: 'Dust thresholds (per currency, "default" required)',
            type: 'bonus-currency-map',
            valueType: 'dust',
            path: 'bonus.configuration.dust_threshold',
          },
          {
            label: 'Dust grace (s)',
            type: 'c-input',
            valueType: 'integer',
            path: 'bonus.configuration.dust_grace_seconds',
          },
        ],
      },
      { label: 'Bookmaker', path: 'bookmaker', enabledPath: 'account.configuration.bookmaker.enabled' },
      {
        label: 'Balance suspend enabled',
        path: 'balance_suspend_enabled',
        enabledPath: 'account.configuration.balance_suspend_enabled.enabled',
      },
      {
        label: 'Balance Suspend Limit',
        path: 'balance_suspend_limit',
        fields: [
          {
            label: 'Balance suspend limit',
            type: 'c-input',
            path: 'account.configuration.balance_suspend_limit',
          },
          {
            label: 'Balance suspend enabled front',
            type: 'b-switch',
            path: 'frontConfiguration.data.balance_suspend_limit_enabled',
          },
        ],
      },
      { label: 'Constraint', path: 'constraint', enabledPath: 'constraint.enabled' },
      {
        label: 'Telegram',
        path: 'telegram',
        enabledPath: 'user.configuration.telegram.enabled',
        fields: [{ label: 'Token', type: 'c-input', path: 'user.configuration.telegram.token' }],
      },
      {
        label: 'Intercom',
        path: 'intercom',
        enabledPath: 'user.configuration.intercom.enabled',
        fields: [
          { label: 'App ID', type: 'c-input', path: 'user.configuration.intercom.appId' },
          { label: 'Token', type: 'c-input', path: 'user.configuration.intercom.token' },
          { label: 'Public App ID', type: 'c-input', path: 'frontConfiguration.data.intercom.publicAppId' },
          { type: 'intercom-options', path: 'frontConfiguration.data.intercom.options' },
        ],
      },
      {
        label: 'Income Access',
        path: 'income-access',
        enabledPath: 'user.configuration.incomeAccess.enabled',
        fields: [
          { label: 'Host', type: 'c-input', path: 'user.configuration.incomeAccess.host' },
          { label: 'Merchant', type: 'c-input', path: 'user.configuration.incomeAccess.merchant' },
          { label: 'Password', type: 'c-input', path: 'user.configuration.incomeAccess.password' },
          {
            label: 'Registration Path',
            type: 'c-input',
            path: 'user.configuration.incomeAccess.registrationPath',
          },
          { label: 'Sales Path', type: 'c-input', path: 'user.configuration.incomeAccess.salesPath' },
          { label: 'Username', type: 'c-input', path: 'user.configuration.incomeAccess.username' },
        ],
      },
      {
        label: 'Partner Matrix',
        path: 'partner-matrix',
        enabledPath: 'user.configuration.partnerMatrix.enabled',
        fields: [
          { label: 'Host', type: 'c-input', path: 'user.configuration.partnerMatrix.host' },
          { label: 'Merchant', type: 'c-input', path: 'user.configuration.partnerMatrix.merchant' },
          { label: 'Password', type: 'c-input', path: 'user.configuration.partnerMatrix.password' },
          {
            label: 'Registration Path',
            type: 'c-input',
            path: 'user.configuration.partnerMatrix.registrationPath',
          },
          { label: 'Sales Path', type: 'c-input', path: 'user.configuration.partnerMatrix.salesPath' },
          { label: 'Username', type: 'c-input', path: 'user.configuration.partnerMatrix.username' },
          {
            label: 'Commission Percent',
            fields: [
              {
                label: 'betfair',
                type: 'c-input',
                path: 'user.configuration.partnerMatrix.commissionPercent.betfair',
              },
              {
                label: 'sportsbook',
                type: 'c-input',
                path: 'user.configuration.partnerMatrix.commissionPercent.sportsbook',
              },
              {
                label: 'casino',
                type: 'c-input',
                path: 'user.configuration.partnerMatrix.commissionPercent.casino',
              },
            ],
          },
        ],
      },
      {
        label: 'Dosta',
        path: 'dosta',
        enabledPath: 'user.configuration.dosta.enabled',
        fields: [
          { label: 'Host', type: 'c-input', path: 'user.configuration.dosta.host' },
          { label: 'Username', type: 'c-input', path: 'user.configuration.dosta.username' },
          { label: 'Password', type: 'c-input', path: 'user.configuration.dosta.password' },
          { label: 'Merchant', type: 'c-input', path: 'user.configuration.dosta.merchant' },
          {
            label: 'Failed Transactions',
            type: 'c-switch',
            path: 'user.configuration.dosta.failedTransactionsEnabled',
          },
          {
            label: 'Failed Transactions Path',
            type: 'c-input',
            path: 'user.configuration.dosta.failedTransactionsPath',
          },
          {
            label: 'Betting Users',
            type: 'c-switch',
            path: 'user.configuration.dosta.usersEnabled',
          },
          {
            label: 'Betting Users Path',
            type: 'c-input',
            path: 'user.configuration.dosta.bettingUsersPath',
          },
        ],
      },
      {
        label: 'Facebook',
        path: 'facebook',
        enabledPath: 'user.configuration.facebook.enabled',
        fields: [
          { label: 'ClientId', type: 'c-input', path: 'user.configuration.facebook.clientId' },
          { label: 'Secret', type: 'c-input', path: 'user.configuration.facebook.secret' },
        ],
      },
      {
        label: 'Twitch',
        path: 'twitch',
        enabledPath: 'user.configuration.twitch.enabled',
        fields: [
          { label: 'ClientId', type: 'c-input', path: 'user.configuration.twitch.clientId' },
          { label: 'Secret', type: 'c-input', path: 'user.configuration.twitch.secret' },
        ],
      },
      {
        label: 'Admin PT',
        path: 'pt',
        fields: [{ label: 'Admin PT', type: 'c-input', path: 'account.configuration.pt.data' }],
      },
      {
        label: 'Money Transfer',
        path: 'money-transfer',
        fields: [
          { label: 'Enabled', type: 'b-switch', path: 'frontConfiguration.data.moneyTransfer.enabled' },
        ],
      },
    ],
  },
  {
    label: 'Services',
    path: 'services',
    children: [
      {
        label: 'File Manager',
        path: 'file-manager',
        fields: [{ type: 'file-manager', path: 'core.configuration.file_manager' }],
      },
      {
        label: 'Graylog',
        path: 'graylog',
        enabledPath: 'core.configuration.graylog.enabled',
        fields: [
          { label: 'Host', type: 'c-input', path: 'core.configuration.graylog.host' },
          { label: 'Port', type: 'c-input', path: 'core.configuration.graylog.port' },
          { label: 'Source', type: 'c-input', path: 'core.configuration.graylog.source' },
        ],
      },
      {
        label: 'Audit Log',
        path: 'audit-log',
        enabledPath: 'core.configuration.audit_log.enabled',
        fields: [
          { label: 'Api Key', type: 'c-input', path: 'core.configuration.audit_log.api_key' },
          { label: 'Host', type: 'c-input', path: 'core.configuration.audit_log.host' },
          { label: 'Port', type: 'c-input', path: 'core.configuration.audit_log.port' },
          { label: 'Username', type: 'c-input', path: 'core.configuration.audit_log.username' },
          { label: 'Password', type: 'c-input', path: 'core.configuration.audit_log.password' },
        ],
      },
      {
        label: 'Contact Us',
        path: 'contact-us',
        enabledPath: 'contact_us.enabled',
        fields: [{ label: 'Email', type: 'c-input', path: 'contact_us.configuration.email' }],
      },
      {
        label: 'Notifications',
        path: 'notifications',
        fields: [
          { label: 'Email', type: 'c-input', path: 'core.configuration.message.email' },
          { label: 'Name', type: 'c-input', path: 'core.configuration.message.name' },
          { label: 'Jira Host', type: 'c-input', path: 'core.configuration.message.jiraHost' },
          { label: 'Jira User', type: 'c-input', path: 'core.configuration.message.jiraUser' },
          { label: 'jira Api Token', type: 'c-input', path: 'core.configuration.message.jiraApiToken' },
          { label: 'Jira Project Key', type: 'c-input', path: 'core.configuration.message.jiraProjectKey' },
        ],
      },
      {
        label: 'Slack',
        path: 'slack',
        enabledPath: 'core.configuration.slack.enabled',
        fields: [
          { label: 'Channel', type: 'c-input', path: 'core.configuration.slack.channel' },
          { label: 'Max Bet Amount', type: 'c-input', path: 'core.configuration.slack.max_bet_amount' },
          { label: 'Token', type: 'c-input', path: 'core.configuration.slack.token' },
        ],
      },
    ],
  },
  {
    label: 'Widgets',
    path: 'widgets',
    children: [
      {
        label: 'Match progress',
        path: 'match-progress',
        fields: [{ label: 'Token', type: 'c-input', path: 'frontConfiguration.data.widgets.matchProgress' }],
      },
    ],
  },
]

function getExchangeSettings(exchangeType) {
  return [
    {
      label: 'Bet Submit Delay (ms)',
      type: 'c-input',
      valueType: 'integer',
      path: `frontConfiguration.data.${exchangeType}.betslip.submitDelay`,
    },
    {
      label: 'Route namespace',
      type: 'b-input',
      path: `frontConfiguration.data.${exchangeType}.prefixUrl`,
    },
    {
      label: 'Prelive enabled',
      type: 'b-switch',
      path: `frontConfiguration.data.${exchangeType}.prelive.enabled`,
    },
    {
      label: 'Prelive title',
      type: 'b-input',
      path: `frontConfiguration.data.${exchangeType}.prelive.title`,
    },
    {
      label: 'Live enabled',
      type: 'b-switch',
      path: `frontConfiguration.data.${exchangeType}.live.enabled`,
    },
    {
      label: 'Live title',
      type: 'b-input',
      path: `frontConfiguration.data.${exchangeType}.live.title`,
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/Projects/Form/tree.js